import EventTitle from "%/dynamic-component-editor/standard-components/event-card/EventTitle.vue";
import EventDescription from "%/dynamic-component-editor/standard-components/event-card/EventDescription.vue";
import EventPrice from "%/dynamic-component-editor/standard-components/event-card/EventPrice.vue";
import EventDate from "%/dynamic-component-editor/standard-components/event-card/EventDate.vue";
import EventStartTime from "%/dynamic-component-editor/standard-components/event-card/EventStartTime.vue";
import EventEndTime from "%/dynamic-component-editor/standard-components/event-card/EventEndTime.vue";
import EventDuration from "%/dynamic-component-editor/standard-components/event-card/EventDuration.vue";
import EventRecurringInfo from "%/dynamic-component-editor/standard-components/event-card/EventRecurringInfo.vue";
import EventImage from "%/dynamic-component-editor/standard-components/event-card/EventImage.vue";
import EventLocation from "%/dynamic-component-editor/standard-components/event-card/EventLocation.vue";
import EventMeetingLink from "%/dynamic-component-editor/standard-components/event-card/EventMeetingLink.vue";
import EventCountdownTimer from "%/dynamic-component-editor/standard-components/event-card/EventCountdownTimer.vue";
import EventLiveBadge from "%/dynamic-component-editor/standard-components/event-card/EventLiveBadge.vue";
import EventParticipantCount from "%/dynamic-component-editor/standard-components/event-card/EventParticipantCount.vue";
import EventStatus from "%/dynamic-component-editor/standard-components/event-card/EventStatus.vue";
import EventVideoRoom from "%/dynamic-component-editor/standard-pages/event-page/EventVideoRoom.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyEvent extends LegacyEntity {
  get elements() {
    return {
      EventTitle,
      EventDescription,
      EventPrice,
      EventDate,
      EventStartTime,
      EventEndTime,
      EventDuration,
      EventRecurringInfo,
      EventImage,
      EventLocation,
      EventMeetingLink,
      EventCountdownTimer,
      EventLiveBadge,
      EventParticipantCount,
      EventStatus,
      EventVideoRoom,
    };
  }
}
